var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMatchDateMessage = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _i18n = _interopRequireDefault(require("../i18n"));

var _PropsHelper = require("./PropsHelper");

var buildMatchDateMessage = function buildMatchDateMessage(match, messageKey, emptyResultCallback) {
  var matchDate = (0, _get.default)(match, 'scheduledStartTime');

  if (matchDate) {
    var isToday = (0, _moment.default)(matchDate).isSame((0, _moment.default)(), 'day');
    var isTomorrow = (0, _moment.default)(matchDate).isSame((0, _moment.default)().add(1, 'days'), 'day');
    var matchDateTranslated;

    if (isToday) {
      matchDateTranslated = (0, _i18n.default)('today').toLowerCase();
    } else if (isTomorrow) {
      matchDateTranslated = (0, _i18n.default)('tomorrow');
    } else {
      matchDateTranslated = (0, _i18n.default)('at_date') + " " + (0, _moment.default)(matchDate).format('DD.MM.YYYY');
    }

    return (0, _i18n.default)(messageKey, {
      matchDate: matchDateTranslated,
      matchTime: (0, _moment.default)(matchDate).format('HH:mm')
    });
  }

  return (0, _PropsHelper.executeFunctionOrUndefined)(emptyResultCallback);
};

exports.buildMatchDateMessage = buildMatchDateMessage;